
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2afa"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2afa"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $35731f67d126b40b$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["6lax2","index.fa44f3d5.js","kcrhc","favicon-white.23c72870.ico","8HO9v","favicon-white-16x16.4b6efd9f.png","WIEvl","favicon-white-32x32.d6c08fa6.png","eFvQW","favicon-white-48x48.d3487e23.png","gxKCj","favicon-white.e08e6155.svg"]'));

const $7901e8051d12ce7d$var$colorScheme = window.matchMedia("(prefers-color-scheme: dark)");
var $6a7e4084b64bd0b9$exports = {};
$6a7e4084b64bd0b9$exports = new URL("favicon-white.23c72870.ico", import.meta.url).toString();


var $375cea4b924ef938$exports = {};
$375cea4b924ef938$exports = new URL("favicon-white-16x16.4b6efd9f.png", import.meta.url).toString();


var $b8fcf4e3f1667e14$exports = {};
$b8fcf4e3f1667e14$exports = new URL("favicon-white-32x32.d6c08fa6.png", import.meta.url).toString();


var $93b1635319c6369a$exports = {};
$93b1635319c6369a$exports = new URL("favicon-white-48x48.d3487e23.png", import.meta.url).toString();


var $48b33089beb93bce$exports = {};
$48b33089beb93bce$exports = new URL("favicon-white.e08e6155.svg", import.meta.url).toString();


const $7901e8051d12ce7d$var$icons = [
    [
        "favicon-ico",
        new URL($6a7e4084b64bd0b9$exports).href
    ],
    [
        "favicon-16",
        new URL($375cea4b924ef938$exports).href
    ],
    [
        "favicon-32",
        new URL($b8fcf4e3f1667e14$exports).href
    ],
    [
        "favicon-48",
        new URL($93b1635319c6369a$exports).href
    ],
    [
        "favicon-svg",
        new URL($48b33089beb93bce$exports).href
    ]
].map(([id, darkHref])=>{
    const element = document.getElementById(id);
    return {
        element: element,
        defaultHref: element.href,
        darkHref: darkHref
    };
});
// Explicit URLs also cover browsers that ignore media queries in SVG favicons.
const $7901e8051d12ce7d$var$updateIcons = ()=>{
    $7901e8051d12ce7d$var$icons.forEach(({ element: element, defaultHref: defaultHref, darkHref: darkHref })=>{
        const href = $7901e8051d12ce7d$var$colorScheme.matches ? darkHref : defaultHref;
        if (element.href !== href) element.href = href;
    });
};
$7901e8051d12ce7d$var$updateIcons();
if ($7901e8051d12ce7d$var$colorScheme.addEventListener) $7901e8051d12ce7d$var$colorScheme.addEventListener("change", $7901e8051d12ce7d$var$updateIcons);
else // Safari 13 and older expose the legacy MediaQueryList listener API.
$7901e8051d12ce7d$var$colorScheme.addListener($7901e8051d12ce7d$var$updateIcons);


//# sourceMappingURL=index.fa44f3d5.js.map
